import { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useForm } from 'react-hook-form';
import { Grid } from '@mui/material';
import { decryptURL, findOnArray } from 'utils/functions';
import { GridContext } from 'contexts/GridContext';
import { DropsContext } from 'contexts/DropsContext';
import InputMask from 'components/InputMask';
import Container from 'components/Container';
import Button from 'components/Button';
import Header from 'components/Header';
import Card from 'components/Card';

const Manutenção = () => {
  const rotina = 'CcustoValor';
  const defaultValues = {
    ccusto_id: null,
    vlrprep: '',
    vlrexec: '',
    inivalid: null,
    fimvalid: null,
  };
  const navigate = useNavigate();
  const { hash } = useParams();
  const decrypt = decryptURL(hash);
  const { drops } = useContext(DropsContext);
  const { postLoading, postGrid } = useContext(GridContext);
  const { control, handleSubmit, reset } = useForm({ defaultValues });

  useEffect(() => {
    reset({ ...defaultValues, ...decrypt });
  }, []);

  const onSubmit = (data) =>
    postGrid({ data: { data, rotina }, cb: () => navigate(-1) });

  return (
    <Container>
      <Header
        titulo={`${Boolean(decrypt?.id) ? 'Editar' : 'Adicionar'} Valor do Centro de Custo`}
        subtitulo={findOnArray(decrypt?.ccusto_id, drops?.Ccusto, 'label')}
      />
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <InputMask
              name="vlrprep"
              control={control}
              label="Valor Hora de Preparo"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputMask
              name="vlrexec"
              control={control}
              label="Valor Hora de Execução"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputMask
              type="date"
              name="inivalid"
              control={control}
              label="Data de Início"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <InputMask
              type="date"
              name="fimvalid"
              control={control}
              label="Data de Término"
            />
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
              loading={postLoading}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
};

export default Manutenção;
